import { render } from "./SpacerBreak.vue?vue&type=template&id=81ff26f8"
const script = {}

import exportComponent from "/home/jordan/Development/CottersChimneySweeps/cchs-mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__